import React from "react"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

const RequiredNote = () => (
    <p className={styles.requiredNote}>
        <span className={styles.req} aria-hidden="true">
            *
        </span>
        Required fields
    </p>
)

export default RequiredNote
